import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const Field = ({ label, children }) => (
  <div>
    <label className="mb-1.5 block text-sm font-semibold text-argia-ink">{label}</label>
    {children}
  </div>
);

export const ContactStep = ({ form, onChange, clientType }) => {
  const set = (key) => (e) => onChange({ ...form, [key]: e.target.value });
  return (
    <div className="space-y-5 rounded-2xl border border-[#2C2A29]/10 bg-white p-6 sm:p-8" data-testid="booking-form">
      <Field label="Nom complet *">
        <Input data-testid="booking-input-name" value={form.name} onChange={set("name")} placeholder="Votre nom et prénom" />
      </Field>
      {clientType === "professionnel" && (
        <Field label="Nom de l'entreprise *">
          <Input data-testid="booking-input-company" value={form.company} onChange={set("company")} placeholder="Ex : Boulangerie du Bourg" />
        </Field>
      )}
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Email *">
          <Input data-testid="booking-input-email" type="email" value={form.email} onChange={set("email")} placeholder="vous@exemple.fr" />
        </Field>
        <Field label="Téléphone *">
          <Input data-testid="booking-input-phone" type="tel" value={form.phone} onChange={set("phone")} placeholder="06 00 00 00 00" />
        </Field>
      </div>
      <Field label="Précisez votre besoin (optionnel)">
        <Textarea data-testid="booking-input-message" value={form.message} onChange={set("message")} placeholder="Quelques mots sur votre situation…" rows={4} />
      </Field>
    </div>
  );
};
